/* eslint-disable array-callback-return */
import FormEditor from 'components/Editors/FormEditor';
import ReportDate from 'components/Editors/ReportDate';
import DataGrid, {
  Column,
  ColumnChooser,
  Export,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  MasterDetail,
  RemoteOperations,
  Scrolling,
  Selection,
} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import React, {useEffect, useRef, useState} from 'react';
import {ObjectSchema} from 'yup';
import {useToggle} from '../hooks/index';
import {DeleteButton, EditButton} from './crud-buttons/Buttons';
import {useDispatch} from 'react-redux';
import {arraysEqualMasterGrid} from './../../helpers/functions';
import {ensureSessionOrRedirect} from '../../helpers/session';
import {
  useActionButtonStyles,
  getActionColumnWidth,
} from './styles/actionButtonStyles';
import {useIsTablet} from 'components/hooks/useIsTablet';

export interface LookupProps {
  id: number;
  name: string;
}
interface MasterGridProps {
  dataSource: any;
  exportName: string;
  filter?: boolean;
  disabledExport?: boolean;
  children: any;
  grouping?: boolean;
  autoWidth?: boolean;
  promiseEdit: Promise<any> | null;
  promiseDelete: Promise<any> | null;
  promiseAdd: Promise<any> | null;
  id: string | Array<string>;
  schema: ObjectSchema;
  columnOptions: any;
  customEditPopup?: boolean;
  componentAddPopup: any;
  integrityId: string | string[];
  integrityName: string;
  integrityGrid: any;
  allowIntegrity?: boolean;
  allowActions?: boolean;
  remoteLookup: RemoteLookupProps[];
  withoutEdit?: WithoutDeleteAndEditProps | null;
  withoutDelete?: WithoutDeleteAndEditProps | null;
  height?: string;
  shouldSaveFilters?: boolean;
  shouldSaveOnlyFilters?: boolean;
  defaultFilterValue?: any;
  addCustomToolbar?: any;
  marginBottom?: string;
  hideToolbar?: boolean;
}

export interface WithoutDeleteAndEditProps {
  column: string;
  equals: number[];
}

export interface RemoteLookupProps {
  column: string;
  keyValue: string;
  displayValue: string;
  dataSource: Promise<any>;
}

interface ButtonsProps {
  e: any;
  promiseEdit: Promise<any> | null;
  promiseDelete: Promise<any> | null;
  id: string | Array<string>;
  schema: ObjectSchema;
  columnOptions: any;
  customEditPopup: boolean;
  initialValues: any;
  refresh: any;
  lookup: RemoteLookupProps[];
  withoutDelete?: WithoutDeleteAndEditProps | null;
  withoutEdit?: WithoutDeleteAndEditProps | null;
}

const MAX_ACTION_BUTTONS = 2;

const Buttons = ({
  e,
  promiseEdit,
  promiseDelete,
  id,
  schema,
  columnOptions,
  initialValues,
  refresh,
  lookup = [],
  customEditPopup = false,
  withoutEdit = null,
  withoutDelete = null,
}: ButtonsProps) => {
  const styles = useActionButtonStyles();

  const isTablet = useIsTablet();

  return (
    <div
      className={isTablet ? styles.tabletContainer : styles.compactContainer}>
      {!customEditPopup && promiseEdit != null && (
        <EditButton
          promise={promiseEdit}
          schema={schema}
          row={e.data.data}
          columnOptions={columnOptions}
          id={id}
          initialValues={initialValues}
          refresh={refresh}
          lookup={lookup}
          withoutEdit={withoutEdit}
        />
      )}
      {promiseDelete != null && (
        <DeleteButton
          id={id}
          promise={promiseDelete}
          row={e.data.data}
          withoutDelete={withoutDelete}
          refresh={refresh}
        />
      )}
    </div>
  );
};

//Le pasamos la funcion, si no es null, significa que el boton existe. si no no existe! Listo..
//Saco el delete del market

const MasterGrid = ({
  dataSource,
  exportName,
  children,
  id,
  schema,
  columnOptions,
  componentAddPopup,
  integrityId,
  integrityName,
  integrityGrid,
  withoutDelete = null,
  withoutEdit = null,
  remoteLookup = [],
  filter = true,
  grouping = true,
  customEditPopup = false,
  disabledExport = false,
  autoWidth = false,
  promiseEdit = null,
  promiseDelete = null,
  promiseAdd = null,
  allowIntegrity = true,
  allowActions = true,
  height = '70vh',
  shouldSaveFilters = false,
  shouldSaveOnlyFilters = false,
  defaultFilterValue,
  addCustomToolbar = null,
  marginBottom = '5vh',
  hideToolbar = false,
  ...props
}: MasterGridProps) => {
  const {open, toggle, setOn} = useToggle();
  const currentSelected = useRef('');
  const refresh = useRef(null);
  const [openReport, setOpenReport] = useState(false);
  const [lookupValues, setLookupValues] = useState<any[]>([]);
  const mount = useRef(true);
  const filterRef = useRef<any>(null);
  const [appliedFilters, setAppliedFilters] = useState<any>([]);
  const dispatch = useDispatch();

  const isTablet = useIsTablet();

  useEffect(() => {
    if (mount.current) {
      if (remoteLookup.length > 0) {
        remoteLookup.map((lookup: any) => {
          lookup.dataSource.then((data: any) => {
            setLookupValues((lookupValues) => [
              ...lookupValues,
              {values: data, ...lookup},
            ]);
          });
        });
      }
    }
    return () => {
      mount.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function toolbarButtons(e: any) {
    if (!hideToolbar) {
      refresh.current = e.component.refresh;
      e.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'refresh',
          hint: i18n2._('Refrescar datos'), //Agregar traduccion
          onClick: () => {
            if (!ensureSessionOrRedirect()) {
              return;
            }
            e.component.refresh();
          },
        },
      });
    }
    if (promiseAdd != null || customEditPopup) {
      e.toolbarOptions.items.push({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'plus',
          hint: i18n2._('Agregar'), //Agregar traduccion
          onClick: setOn,
        },
      });
    }
    if (allowIntegrity) {
      e.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'clock',
          hint: i18n2._('Tabla de integrity'), //Agregar traduccion
          onClick: () => selectionChanged(e),
        },
      });
      e.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'event',
          hint: i18n2._('Reporte'), //Agregar traduccion
          onClick: () => setOpenReport(true),
        },
      });
    }
    if (addCustomToolbar) {
      addCustomToolbar.map((item: any) => {
        e.toolbarOptions.items.unshift(item);
      });
    }
  }

  function selectionChanged(e: any) {
    e.component.collapseAll(-1);
    e.component.expandRow(currentSelected.current);
    if (typeof currentSelected.current !== 'undefined') {
      e.component.deselectRows(currentSelected.current);
    }
  }

  const handleSelection = (e: any) => {
    currentSelected.current = e.currentSelectedRowKeys[0];
  };

  const {initialValues = {}}: any = props;

  const saveFilterForLoadoptions = (e: any) => {
    const filters = e.component.getCombinedFilter(true);
    if (!arraysEqualMasterGrid(appliedFilters, filters)) {
      dispatch({type: 'SAVE_FILTER', payload: filters});
      setAppliedFilters(filters);
    }
  };

  return (
    <DataGrid
      ref={filterRef}
      paging={{enabled: false}}
      allowColumnReordering={true}
      allowColumnResizing={true}
      columnAutoWidth={autoWidth}
      dataSource={dataSource}
      onToolbarPreparing={toolbarButtons} //Te permite agregar botones en el toolbar
      // remoteOperations={true}
      filterValue={defaultFilterValue}
      rowAlternationEnabled={true}
      showBorders={true}
      height={height}
      onContentReady={(e: any) => {
        shouldSaveFilters && saveFilterForLoadoptions(e);
        shouldSaveOnlyFilters && saveFilterForLoadoptions(e);
      }}
      style={{
        marginBottom: marginBottom,
        paddingRight: '1vh',
        paddingLeft: '1vh',
      }}
      onSelectionChanged={handleSelection} //Esto trae errores.. no te permite seleccionar bien el boton de eliminar
      keyExpr={id}
      onExporting={(e) => {
        if (!ensureSessionOrRedirect()) {
          e.cancel = true;
          return;
        }
      }}
      {...props}>
      <Export
        enabled={!hideToolbar && !disabledExport}
        allowExportSelectedData={false}
        fileName={exportName}
      />
      <Selection
        mode="single"
        selectAllMode={'allPages'}
        showCheckBoxesMode={'always'}
      />
      <FilterRow visible={filter} />
      <GroupPanel visible={grouping && !hideToolbar} />
      <HeaderFilter visible={filter} />
      <Scrolling mode="infinite" />
      <ColumnChooser enabled={!hideToolbar} mode="dragAndDrop" />
      <MasterDetail enabled={false} component={integrityGrid} />
      <RemoteOperations
        groupPaging={true}
        filtering={true}
        sorting={true}
        grouping={true}
      />
      {allowActions && (
        <Column
          buttons={true}
          caption={i18n2._('Acciones')}
          cellComponent={(e: any) => (
            <Buttons
              e={e}
              promiseDelete={promiseDelete}
              promiseEdit={promiseEdit}
              id={id}
              schema={schema}
              columnOptions={columnOptions}
              customEditPopup={customEditPopup}
              initialValues={initialValues}
              refresh={refresh}
              lookup={lookupValues}
              withoutDelete={withoutDelete}
              withoutEdit={withoutEdit}
            />
          )}
          width={getActionColumnWidth(MAX_ACTION_BUTTONS, isTablet)}
          fixed
          alignment="right"
        />
      )}
      {children}
      {customEditPopup
        ? componentAddPopup(open, toggle, refresh.current)
        : open && (
            <FormEditor
              schema={schema}
              open={open}
              setOpen={toggle}
              lookup={lookupValues}
              promise={promiseAdd}
              type={'add'}
              columnOptions={columnOptions}
              initialValues={initialValues}
              refresh={refresh}
            />
          )}
      {openReport && (
        <ReportDate
          openReport={openReport}
          setOpenReport={setOpenReport}
          integrityName={integrityName}
          integrityId={integrityId}
          selection={currentSelected.current}
        />
      )}
    </DataGrid>
  );
};
/// <Scrolling mode="standar" /> este modo te trae TODOS los datos, el modo infinite, te trae x cantidad de filas y tarda mucho menos.
export default MasterGrid;
